import { Box } from '@mui/material';
import React, { useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom';

const BlogGrowth = () => {

    const RecentBlog = [
        {
            img: './assets/images/blog-detail-1.png',
            title: 'Is slower team communication a bad thing?',
            date: '4 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-2.png',
            title: 'The Power of Smart Warehouse Management System in 2024',
            date: '23 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-3.png',
            title: 'Is slower team communication a bad thing?',
            date: '14 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-1.png',
            title: 'Is slower team communication a bad thing?',
            date: '8 March 2024',
            path: '/blog-detail'
        },
    ]

    const blogTag = [
        {
            tagTitle: 'Development',
            path: '/DevelopBlogList'
        },
        {
            tagTitle: 'Technology',
            path: '/TechBlogList'
        },
        {
            tagTitle: 'HTML',
            path: '/HtmlBlogList'
        },
        {
            tagTitle: 'Branding',
            path: '/BrandBlogList'
        },
        {
            tagTitle: 'PHP',
            path: '/PhpBlogList'
        }
    ]

    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate(); // Hook for programmatic navigation

    // Handle the search input change
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    // Handle form submission (search on Enter key press)
    const handleSearchSubmit = (e) => {
        e.preventDefault();

        // Filter the tags based on the search query
        const filteredTags = blogTag.filter((tag) =>
            tag.tagTitle.toLowerCase().includes(searchQuery.toLowerCase())
        );

        const filteredBlogs = RecentBlog.filter((blog) =>
            blog.title.toLowerCase().includes(searchQuery.toLowerCase())
        );

        // Navigate to the search results page with the filtered data
        navigate('/noBlog', {
            state: { searchQuery, filteredTags, filteredBlogs },
        });
    };

    return (
        <>
                
            {/* Blog Detail Banner */}
            <section className='blog-detail-page'>
                <div className='blog-detail-bg'>    
                    <div className='c-detail-shap-1  blog-det-1'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    <div className='blog-detail-shap-1 blog-det-1'>
                        <img src="../assets/images/whi-2.svg" alt="" />
                    </div>
                    <div className='about-shap-3 blog-det-1'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-4 blog-det-1'>
                        <img src="../assets/images/about-shap-2.png" alt="" />
                    </div>
                    <div className='about-shap-5 blog-det-1'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <Container>
                        <div className='row justify-content-center'>
                            <div className='col-xl-12 col-lg-10 col-md-11 col-sm-11 col-11 col-padding'>
                                <div className='blogdetail-content' data-aos="fade-right" data-aos-duration="2000">
                                    <h3>The Importance of UI/UX in Modern Software </h3>
                                    <h6>14 Jan 2025</h6>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </section>
        
            <div className='blog-detail-position'>
                <Container>
                    <div className='row justify-content-center'>
                        <div className='col-xl-12 col-lg-10 col-md-11 col-sm-11 col-11' data-aos="zoom-in-up" data-aos-duration="2500">
                            <div className='blog-detail-1'>
                                <img src="../assets/images/blog_3.png" alt="" />
                            </div>
                        </div>
                    </div>

                    <div className='blog-detail-padding'>
                        <Row>
                            <div className="col-xl-8 col-lg-7">

                                <p className='blog-para'>User Interface (UI) and User Experience (UX) design are no longer optional; they are central to the success of any digital product. Whether it’s a mobile app, website, or software platform, thoughtful UI/UX design can dramatically influence user engagement, retention, and overall satisfaction. </p>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1500">
                                    <h3>First Impressions Matter  </h3>
                                    <p>Users form opinions about an app or website within seconds. Clean layouts, intuitive navigation, and responsive design play a critical role in building trust. A confusing or clunky interface, on the other hand, leads to abandonment. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1650">
                                    <h3>User-Centric Design Increases Engagement  </h3>
                                    <p>UX design is rooted in understanding the user—how they think, what they need, and how they behave. By designing with empathy and clarity, you ensure that users can achieve their goals with minimal friction, which in turn leads to greater satisfaction and longer app usage. </p>
                                </div>
                                
                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1800">
                                    <h3>Better UX Reduces Support Costs </h3>
                                    <p>An intuitive interface can reduce the need for customer support. When users can figure things out on their own, there are fewer support tickets, lower onboarding costs, and more time for your team to focus on growth and innovation. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1950">
                                    <h3>Boosts Conversions and ROI </h3>
                                    <p>Whether it’s an eCommerce app or a SaaS platform, great UI/UX can directly impact conversion rates. Smooth checkout flows, easy form filling, and smart micro-interactions all contribute to increased user trust and improved sales performance. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="2100">
                                    <h3>Accessibility and Inclusivity </h3>
                                    <p>Modern UI/UX practices also prioritize accessibility. Designing for all users—including those with disabilities—ensures your product is usable by a wider audience and compliant with global standards. </p>

                                    <p>In today’s competitive tech landscape, good code isn’t enough. Exceptional UI/UX is what turns a functioning product into a loved and successful one. </p>
                                </div>

                            </div>
                            <div className="col-xl-4 col-lg-5 mt-30">
                                <div className='ml-lg-30 ml-0'>
                                    <div className=' mb-20' data-aos="fade-up-left" data-aos-duration="3000">
                                        <div className='search-border'>
                                            <h4>Search</h4>
                                            <form className='search-box position-relative' onSubmit={handleSearchSubmit}>
                                                <input className='w-100' placeholder='Search Your Keywords…' type="text" value={searchQuery}  onChange={handleSearchChange} />
                                                <button className='search-icon' type="submit">
                                                    <img src="../assets/images/search-icon.svg" alt="" />
                                                </button>
                                            </form>
                                        </div>
                                    </div>


                                    <div className=' mb-20' data-aos="fade-up-left" data-aos-duration="2500">
                                        <div className='blog-border'>
                                            <h4>Recent Blog</h4>
                                            <div className='border-blog'></div>
                                            <ul>
                                                {RecentBlog.map((blog, index) => (
                                                    <li key={index}>
                                                        <Link to={blog.path}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '13px'
                                                            }}>
                                                                <div className='blog-list-img'>
                                                                    <img src={blog.img} alt="" />
                                                                </div>
                                                                <div className='blog-list-text'>
                                                                    <h6>{blog.title}</h6>
                                                                    <p>{blog.date}</p>
                                                                </div>
                                                            </Box>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='blog-border' data-aos="fade-up-left" data-aos-duration="2000">
                                        <h4>Tag Cloud</h4>
                                        <div className='border-blog'></div>
                                        
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '10px'
                                        }}>
                                            {
                                                blogTag.map((tag,index) => (
                                                    <Link key={index} to={tag.path}>
                                                        <p className="tag-badge">{tag.tagTitle}</p>
                                                    </Link>
                                                ))
                                            }
                                        </Box>
                                        
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </div>
                </Container>
            </div>
        
        </>
    )
}

export default BlogGrowth
